module.exports = __webpack_public_path__ + "img/aeroland-digital-store-image-02.a9ffedd8.png";